import { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import AboutMe from './pages/AboutMe/AboutMe';
import Gallery from './pages/Gallery/Gallery';
import ProtectedGalleryRoute from './templates/ProtectedGalleryRoute/ProtectedGalleryRoute.jsx';
import './App.css';
import NotFound from './pages/NotFound/NotFound.jsx';
import Contact from './pages/Contact/Contact.jsx';
import Blog from './pages/Blog/Blog.jsx';
import BlogDetail from './pages/BlogDetail/BlogDetail.jsx';
import FortuneCookie from './pages/FortuneCookie/FortuneCookie.jsx';
import ScrollToTop from './components/ScrollToTop/ScrollToTop.jsx';

// Capital One
import Pdp from './pages/Projects/CapitalOne/Pdp/Pdp';
import MultiForm from './pages/Projects/CapitalOne/MultiForm/MultiForm';
import Lighthouse from './pages/Projects/CapitalOne/Lighthouse/Lighthouse.jsx';
import CreditKeeper from './pages/Projects/CapitalOne/CreditKeeper/CreditKeeper.jsx';

// Helcim
import Ach from './pages/Projects/Helcim/Ach/Ach';
import Email from './pages/Projects/Helcim/Email/Email';

//flashfood
import Ebt from './pages/Projects/Flashfood/Ebt/Ebt';

// Side project
import Redyy from './pages/Projects/SideProject/Redyy/Redyy.jsx';

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectedPath = sessionStorage.getItem('redirect');
    if (redirectedPath) {
      sessionStorage.removeItem('redirect');
      navigate(redirectedPath, { replace: true });
    }
  }, [navigate]);

  return (
    <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about_me" element={<AboutMe />} />
      <Route path="/featured-work" element={<Gallery />} />
      <Route path="/404" element={<NotFound />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      <Route path="/fortune-cookie" element={<FortuneCookie />} />
      
      <Route
        path="/featured-work/email"
        element={
          <ProtectedGalleryRoute>
            <Email />
          </ProtectedGalleryRoute>
        }
      />
      <Route
        path="/featured-work/ach"
        element={
          <ProtectedGalleryRoute>
            <Ach />
          </ProtectedGalleryRoute>
        }
      />
      <Route
        path="/featured-work/lighthouse"
        element={
          <ProtectedGalleryRoute>
            <Lighthouse />
          </ProtectedGalleryRoute>
        }
      />
      <Route
        path="/featured-work/pdp"
        element={
          <ProtectedGalleryRoute>
            <Pdp />
          </ProtectedGalleryRoute>
        }
      />
      <Route
        path="/featured-work/multiform"
        element={
          <ProtectedGalleryRoute>
            <MultiForm />
          </ProtectedGalleryRoute>
        }
      />
      <Route
        path="/featured-work/credit-keeper"
        element={
          <ProtectedGalleryRoute>
            <CreditKeeper />
          </ProtectedGalleryRoute>
        }
      />
      <Route
        path="/featured-work/side-project/redyy"
        element={
          <ProtectedGalleryRoute>
            <Redyy />
          </ProtectedGalleryRoute>
        }
      />
      <Route
        path="/featured-work/ebt"
        element={
          <ProtectedGalleryRoute>
            <Ebt />
          </ProtectedGalleryRoute>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  );
}

export default App;